import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import T from 'prop-types'
import { List } from 'immutable'
import SelectList from 'components/common/SelectList'
import { ALL_SELECTED } from 'constants/index'
import messages from '../translate'

function FilterSiteGroups({
  activeSiteGroups,
  isLoadSiteGroupsData,
  logbookSiteGroups,
  handleSiteGroupsChange,
  intl: { formatMessage },
}) {
  return (
    <SelectList
      multiple
      withCheckBox
      hasAllValueOption
      outMultipleValues={{
        all: ALL_SELECTED,
      }}
      variant="outlined"
      name="site groups"
      label={formatMessage(messages.siteGroup)}
      list={logbookSiteGroups}
      value={activeSiteGroups}
      onClose={handleSiteGroupsChange}
      disabled={isLoadSiteGroupsData}
      map={{
        index: 'id',
        text: 'name',
      }}
    />
  )
}

FilterSiteGroups.propTypes = {
  activeSiteGroups: T.instanceOf(Array).isRequired,
  isLoadSiteGroupsData: T.bool.isRequired,
  logbookSiteGroups: T.instanceOf(List).isRequired,
  handleSiteGroupsChange: T.func.isRequired,
  intl: T.instanceOf(Object).isRequired,
}

export default connect(state => ({
  isLoadSiteGroupsData: state.getIn(['logbook', 'isLoadSiteGroupsData']),
  logbookSiteGroups: state.getIn(['logbook', 'logbookSiteGroups']),
}))(injectIntl(FilterSiteGroups))
